import { Button, Stack, Typography } from "@mui/material";
import Spacing from "../../components/space";
import {
  CheckCircle,
  ErrorOutline,
  InfoOutlined,
  WarningOutlined,
} from "@mui/icons-material";

type StatusCardProps = {
  message: string;
  severity?: "success" | "error" | "warning" | "info";
  primaryAction?: { text: string; onClick?: () => void };
  secondaryAction?: { text: string; onClick?: () => void };
  detail?: JSX.Element;
};

export function StatusCard(props: StatusCardProps) {
  const { severity, message, primaryAction, secondaryAction, detail } = props;

  return (
    <Stack p={2} alignItems="center">
      {severity === "success" ? (
        <CheckCircle color="success" fontSize="large" />
      ) : null}
      {severity === "warning" ? (
        <WarningOutlined color="warning" fontSize="large" />
      ) : null}
      {severity === "error" ? (
        <ErrorOutline color="error" fontSize="large" />
      ) : null}
      {severity === "info" ? (
        <InfoOutlined color="info" fontSize="large" />
      ) : null}

      <Spacing />
      <Typography fontWeight={400}>{message}</Typography>
      <Spacing />
      {detail ? detail : null}
      <Spacing />
      <Stack justifyContent="space-around" direction="row" width="100%">
        {primaryAction ? (
          <Button onClick={primaryAction?.onClick} variant="contained">
            {primaryAction?.text}
          </Button>
        ) : null}
        {secondaryAction ? (
          <Button variant="outlined" onClick={secondaryAction?.onClick}>
            {secondaryAction?.text}
          </Button>
        ) : null}
      </Stack>
    </Stack>
  );
}
